import React from 'react';
import PropTypes from 'prop-types';

const Subscriptions = ({ theme, fill, ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.9">
      <path
        d="M19.1666 11.9019V16.7528C19.1666 18.0851 18.0848 19.1669 16.7525 19.1669H16.1262C16.707 19.1669 16.7639 17.5157 16.7525 16.7528V14.3159C16.7525 12.9836 17.8343 11.9019 19.1666 11.9019Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M8.07565 0.845215C8.07565 2.17751 6.99388 3.25929 5.66158 3.25929H3.24751V3.63507C3.24751 3.63507 3.11086 0.845215 3.86241 0.845215H8.07565Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M16.1262 19.1668H0.833252V3.24758C0.833252 1.91528 1.91503 0.833496 3.24732 0.833496H3.86223C3.11068 0.833496 3.24732 3.62335 3.24732 3.62335V16.7527H16.7525C16.7525 17.5157 16.7069 19.1668 16.1262 19.1668Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M12.2443 3.53735C11.6401 3.53735 11.1458 3.043 11.1458 2.4388V1.09856C11.1458 0.49435 11.6401 0 12.2443 0C12.8485 0 13.3429 0.49435 13.3429 1.09856V2.4388C13.3429 3.05399 12.8485 3.53735 12.2443 3.53735Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M16.0011 3.53735C15.3969 3.53735 14.9026 3.043 14.9026 2.4388V1.09856C14.9026 0.49435 15.3969 0 16.0011 0C16.6054 0 17.0997 0.49435 17.0997 1.09856V2.4388C17.0997 3.05399 16.6054 3.53735 16.0011 3.53735Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M15.1442 6.55845H13.4963V4.91061C13.4963 4.66893 13.6941 4.47119 13.9358 4.47119H15.5836V6.11903C15.5836 6.36071 15.3859 6.55845 15.1442 6.55845Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M13.5662 3.94751L13.5513 3.93262L13.5662 3.94751Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M18.5497 1.4502V9.06319C18.5497 10.5023 17.3852 11.6668 15.9461 11.6668H15.6056C16.3855 11.6668 16.3526 9.07418 16.3526 9.07418V9.06319V3.64731H10.9367C10.717 3.64731 10.5412 3.82308 10.5302 4.04279C10.5302 4.04279 10.4973 1.4502 11.2772 1.4502H18.5497Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M15.6057 11.6668H8.33325V4.05377C8.33325 2.61467 9.49772 1.4502 10.9368 1.4502H11.2774C10.4974 1.4502 10.5304 4.04279 10.5304 4.04279V4.05377V9.46966H15.9462C16.166 9.46966 16.3417 9.29389 16.3527 9.07418C16.3527 9.07418 16.3857 11.6668 15.6057 11.6668Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
    </g>
  </svg>
);

Subscriptions.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Subscriptions;
